<div class="flex min-w-0 items-center gap-2.5">
  <div
    aria-hidden="true"
    class="flex h-2 min-w-0 overflow-hidden rounded-sm"
    data-testid="stacked-bar"
    [class.flex-1]="!width()"
    [class.shrink-0]="!!width()"
    [style.width.px]="width() || null"
    [style.background]="getBarToneBackground('empty')"
  >
    @for (segment of visibleSegments(); track $index) {
      <span
        class="h-full"
        data-testid="stacked-bar-segment"
        [attr.data-tone]="segment.tone"
        [style.width.%]="segment.percent"
        [style.background]="getBarToneBackground(segment.tone)"
        [matTooltip]="segment.label ?? ''"
        [matTooltipDisabled]="!segment.label"
      ></span>
    }
  </div>

  <ng-content />
</div>
